import { databasesToContentId } from './constants';
import { getDatabaseWithAttachments } from './databaseWithAttachments';
import { databaseWithBasicFields } from './databaseWithBasicFields';
import { getDatabaseWithContent } from './databaseWithContent';
import { getDatabaseWithFilters } from './databaseWithFilters';
import { getDatabaseWithJiraIssueFieldsAndComments } from './databaseWithJiraIssueFieldsAndComments';
import { getDatabaseWithSampleCsvManyRows } from './databaseWithSampleCsvManyRows';
import { getDatabaseWithSampleCsvStructure } from './databaseWithSampleCsvStructure';
import { getDatabaseWithSmallCsvStructureWithUgc } from './databaseWithSampleCsvStructureWithUgc';
import { getDatabaseWithSelfReferenceEntryLinkField } from './databaseWithSelfReferenceEntryLinkField';
import { getDatabaseWithUserAndLinkField } from './databaseWithUserAndLinkField';
import { databaseWithUserField } from './databaseWithUserField';
import { databaseWithViewsOverflow } from './databaseWithViewsOverflow';
import { getEmptyDatabase } from './emptyDatabase';

export default {
  emptyDatabase: {
    database: getEmptyDatabase(),
    contentId: databasesToContentId['emptyDatabase'],
  },
  databaseWithViewsOverflow: {
    database: databaseWithViewsOverflow(),
    contentId: databasesToContentId['databaseWithViewsOverflow'],
  },
  databaseWithSampleCsvStructure: {
    database: getDatabaseWithSampleCsvStructure(),
    contentId: databasesToContentId['databaseWithSampleCsvStructure'],
  },
  databaseWithSampleCsvStructureWithUgc: {
    database: getDatabaseWithSmallCsvStructureWithUgc(),
    contentId: databasesToContentId['databaseWithSampleCsvStructureWithUgc'],
  },
  databaseWithSampleCsvManyRows: {
    database: getDatabaseWithSampleCsvManyRows(),
    contentId: databasesToContentId['databaseWithSampleCsvManyRows'],
  },
  databaseWithContent: {
    database: getDatabaseWithContent(),
    contentId: databasesToContentId['databaseWithContent'],
  },
  databaseWithUserField: {
    database: databaseWithUserField(),
    contentId: databasesToContentId['databaseWithUserField'],
  },
  databaseWithBasicFields: {
    database: databaseWithBasicFields(),
    contentId: databasesToContentId['databaseWithBasicFields'],
  },
  databaseWithUserAndLinkField: {
    database: getDatabaseWithUserAndLinkField(),
    contentId: databasesToContentId['databaseWithUserAndLinkField'],
  },
  databaseWithSelfReferenceEntryLinkField: {
    database: getDatabaseWithSelfReferenceEntryLinkField(),
    contentId: databasesToContentId['databaseWithSelfReferenceEntryLinkField'],
  },
  databaseWithFilters: {
    database: getDatabaseWithFilters(),
    contentId: databasesToContentId['databaseWithFilters'],
  },
  databaseWithJiraIssueFieldsAndComments: {
    database: getDatabaseWithJiraIssueFieldsAndComments(),
    contentId: databasesToContentId['databaseWithJiraIssueFieldsAndComments'],
  },
  databaseWithAttachments: {
    database: getDatabaseWithAttachments(),
    contentId: databasesToContentId['databaseWithAttachments'],
  },
};
